import React, { FC } from 'react';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { connect } from 'react-redux';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getPartByID } from '@reducers/parts';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { getNCFileByPartId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { DETAILS_SCREENS_CONTAINER_STYLES, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { View } from 'react-native';
import BatchTimeLine from '@v2/pages/batch/details/modules/batch/components/BatchTimeline/BatchTimeline';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { LoadSingleBatch } from '@interfaces/methods';
import { fullWidth, width } from '@components/frame';
import { isWeb } from '@helpers';

interface PartDetailsBatchTimelineProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
  loadSingleBatch: LoadSingleBatch;
}

const PartDetailsBatchTimelineComponent: FC<PartDetailsBatchTimelineProps> = ({
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  loadSingleBatch,
  batch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    getNCFileByPartId,
    operationsSearch,
    loadSingleBatch,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
      <View
        style={{
          ...DETAILS_SCREENS_CONTAINER_STYLES,
          marginInline: 'auto',
          width: '100%',
        }}
      >
        <BatchTimeLine
          productionBatchId={batch?.data?.productionBatchId ?? undefined}
          width={isWeb ? fullWidth : width}
          withoutList
          horizontalOffset={SCREEN_PADDING_HORIZONTAL * 2}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const PartDetailsBatchTimeline = connect(({ batch: { batch } }) => ({ batch }), {
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  loadSingleBatch,
})(PartDetailsBatchTimelineComponent);

export { PartDetailsBatchTimeline };
